export const buildExternalTooltip = (formatter) => (context) => {
  const { chart, tooltip } = context
  let tooltipEl = document.getElementById('chartjs-tooltip')

  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.id = 'chartjs-tooltip'
    tooltipEl.innerHTML = '<table></table>'
    document.body.appendChild(tooltipEl)
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  if (tooltip.body) {
    const bodyLines = tooltip.body.map(bodyItem => bodyItem.lines)
    let innerHtml = '<div class="d-flex flex-column"></div><div class="d-flex flex-column">'

    bodyLines[0].forEach((body) => {
      const line = formatter ? formatter(body) : body
      innerHtml += `<span>${line}</span>`
    })
    innerHtml += '</div>'

    const tableRoot = tooltipEl.querySelector('table')
    tableRoot.innerHTML = innerHtml
  }

  const position = chart.canvas.getBoundingClientRect()
  const caretX = tooltip.caretX || 0
  const caretY = tooltip.caretY || 0
  const caretPosition = caretX > position.left
    ? position.left + window.pageXOffset + caretX - 60
    : position.left + window.pageXOffset + caretX

  tooltipEl.style.opacity = 1
  tooltipEl.style.backgroundColor = 'rgba(0,0,0,0.73)'
  tooltipEl.style.color = 'white'
  tooltipEl.style.position = 'absolute'
  tooltipEl.style.left = `${caretPosition}px`
  tooltipEl.style.top = `${position.top + window.pageYOffset + caretY}px`
  tooltipEl.style.fontFamily = tooltip.options.bodyFont.family
  tooltipEl.style.fontSize = `${tooltip.options.bodyFont.size}px`
  tooltipEl.style.fontStyle = tooltip.options.bodyFont.style
  tooltipEl.style.padding = `${tooltip.options.padding}px`
  tooltipEl.style.pointerEvents = 'none'
}
